/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface HomepageDataInnerOneOf
 */
export interface HomepageDataInnerOneOf {
    /**
     *
     * @type {string}
     * @memberof HomepageDataInnerOneOf
     */
    __component?: HomepageDataInnerOneOfComponentEnum;
    /**
     *
     * @type {string}
     * @memberof HomepageDataInnerOneOf
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof HomepageDataInnerOneOf
     */
    text?: string;
    /**
     *
     * @type {string}
     * @memberof HomepageDataInnerOneOf
     */
    mode?: HomepageDataInnerOneOfModeEnum;
    /**
     *
     * @type {string}
     * @memberof HomepageDataInnerOneOf
     */
    closeAction?: HomepageDataInnerOneOfCloseActionEnum;
}

export const HomepageDataInnerOneOfComponentEnum = {
    Message: 'message.message',
    Banner: 'message.banner',
    Slider: 'message.slider',
} as const;

export type HomepageDataInnerOneOfComponentEnum =
    (typeof HomepageDataInnerOneOfComponentEnum)[keyof typeof HomepageDataInnerOneOfComponentEnum];
export const HomepageDataInnerOneOfModeEnum = {
    Once: 'once',
    Always: 'always',
} as const;

export type HomepageDataInnerOneOfModeEnum =
    (typeof HomepageDataInnerOneOfModeEnum)[keyof typeof HomepageDataInnerOneOfModeEnum];
export const HomepageDataInnerOneOfCloseActionEnum = {
    None: 'none',
    Once: 'once',
    Always: 'always',
} as const;

export type HomepageDataInnerOneOfCloseActionEnum =
    (typeof HomepageDataInnerOneOfCloseActionEnum)[keyof typeof HomepageDataInnerOneOfCloseActionEnum];
